/* tslint:disable */
/* eslint-disable */
/**
 * Localingos API
 * Developer-first automated localization platform powered by AI. Sync your project and continuously localize only what changed.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Supported locale codes
 * @export
 * @enum {string}
 */

export const LocaleCode = {
    EnUs: 'en-US',
    EnGb: 'en-GB',
    EnCa: 'en-CA',
    EnAu: 'en-AU',
    EsEs: 'es-ES',
    EsMx: 'es-MX',
    EsAr: 'es-AR',
    FrFr: 'fr-FR',
    FrCa: 'fr-CA',
    DeDe: 'de-DE',
    DeAt: 'de-AT',
    ItIt: 'it-IT',
    PtPt: 'pt-PT',
    PtBr: 'pt-BR',
    RuRu: 'ru-RU',
    JaJp: 'ja-JP',
    KoKr: 'ko-KR',
    ZhCn: 'zh-CN',
    ZhTw: 'zh-TW',
    ArSa: 'ar-SA',
    HiIn: 'hi-IN',
    NlNl: 'nl-NL',
    SvSe: 'sv-SE',
    DaDk: 'da-DK',
    NoNo: 'no-NO',
    FiFi: 'fi-FI',
    PlPl: 'pl-PL',
    ElGr: 'el-GR',
    TrTr: 'tr-TR',
    HeIl: 'he-IL',
    ThTh: 'th-TH',
    ViVn: 'vi-VN',
    IdId: 'id-ID',
    MsMy: 'ms-MY',
    TlPh: 'tl-PH',
    UkUa: 'uk-UA',
    CsCz: 'cs-CZ',
    SkSk: 'sk-SK',
    HuHu: 'hu-HU',
    RoRo: 'ro-RO',
    BgBg: 'bg-BG',
    HrHr: 'hr-HR',
    SrRs: 'sr-RS',
    SlSi: 'sl-SI',
    EtEe: 'et-EE',
    LvLv: 'lv-LV',
    LtLt: 'lt-LT',
    MtMt: 'mt-MT',
    GaIe: 'ga-IE',
    CyGb: 'cy-GB',
    IsIs: 'is-IS',
    MkMk: 'mk-MK',
    SqAl: 'sq-AL',
    EuEs: 'eu-ES',
    CaEs: 'ca-ES',
    GlEs: 'gl-ES',
    NbNo: 'nb-NO',
    NnNo: 'nn-NO',
    FilPh: 'fil-PH',
    BnBd: 'bn-BD',
    BnIn: 'bn-IN',
    TaIn: 'ta-IN',
    TeIn: 'te-IN',
    MlIn: 'ml-IN',
    KnIn: 'kn-IN',
    MrIn: 'mr-IN',
    GuIn: 'gu-IN',
    PaIn: 'pa-IN',
    UrPk: 'ur-PK',
    SiLk: 'si-LK',
    NeNp: 'ne-NP',
    KmKh: 'km-KH',
    LoLa: 'lo-LA',
    MyMm: 'my-MM',
    JvId: 'jv-ID',
    SuId: 'su-ID',
    FaIr: 'fa-IR',
    ArEg: 'ar-EG',
    ArAe: 'ar-AE',
    AzAz: 'az-AZ',
    KaGe: 'ka-GE',
    HyAm: 'hy-AM',
    KkKz: 'kk-KZ',
    UzUz: 'uz-UZ',
    MnMn: 'mn-MN',
    KyKg: 'ky-KG',
    TgTj: 'tg-TJ',
    TkTm: 'tk-TM',
    PsAf: 'ps-AF',
    CkbIq: 'ckb-IQ',
    SwKe: 'sw-KE',
    AfZa: 'af-ZA',
    AmEt: 'am-ET',
    ZuZa: 'zu-ZA',
    XhZa: 'xh-ZA',
    YoNg: 'yo-NG',
    IgNg: 'ig-NG',
    HaNg: 'ha-NG',
    SoSo: 'so-SO',
    MgMg: 'mg-MG',
    RwRw: 'rw-RW',
    BeBy: 'be-BY',
    BsBa: 'bs-BA',
    LbLu: 'lb-LU',
    FyNl: 'fy-NL',
    GdGb: 'gd-GB',
    FoFo: 'fo-FO',
    RmCh: 'rm-CH',
    SrMe: 'sr-ME'
} as const;

export type LocaleCode = typeof LocaleCode[keyof typeof LocaleCode];



